import { FC } from 'react';

interface MeshProps {
  className?: string;
}

export const Mesh: FC<MeshProps> = ({ className }) => {
  return (
    <div className={`fixed inset-0 -z-10 overflow-hidden ${className}`}>
      <div 
        className="absolute inset-0"
        style={{
          transform: 'translateZ(0)', // Force GPU acceleration
          backfaceVisibility: 'hidden'
        }}
      >
        {/* Base gradient */}
        <div className="absolute inset-0 bg-gradient-to-r from-rose-100/30 via-sky-200/30 to-indigo-100/30" />
        
        {/* Animated overlay with better performance */}
        <div className="absolute inset-0 animate-gradient-slow opacity-50">
          <div 
            className="absolute h-[200%] w-[200%] -top-1/2 -left-1/2 bg-[radial-gradient(circle_at_50%_50%,rgba(254,242,242,0.4),rgba(186,230,253,0.1))]"
            style={{ transform: 'translateZ(0)' }}
          />
        </div>
      </div>
    </div>
  );
};

// Add CSS property definition for modern browsers
if (typeof document !== 'undefined') {
  // Only run in browser environment
  try {
    CSS.registerProperty({
      name: '--gradient-angle',
      syntax: '<angle>',
      initialValue: '0deg',
      inherits: false,
    });
  } catch (e) {
    // Fallback for browsers that don't support @property
    console.debug('CSS.registerProperty not supported');
  }
}
